module.exports = __webpack_public_path__ + "img/39.c1edf8c7.png";